import React from 'react';

import styles from './product-row.scss';
import { withDCOnly } from '../../common/Utills';

const statusContent = {
	APPROVAL_PENDING: {
		statusLabel: 'Approval Pending'
	},
	AUDIT_PENDING: {
		statusLabel: 'Audit Pending'
	},
	INVENTORY_AUDIT_PENDING: {
		statusLabel: 'Inventory Audit Pending',
		extraClass: 'invent-pending'
	},
	AWAITING_INVENTORY_COMPLIANCE: {
		statusLabel: 'Awaiting Inventory Compliance',
		extraClass: 'invent-comp'
	},
	DELETION_PENDING: {
		statusLabel: 'Deletion Pending',
		extraClass: 'delete'
	},
	PRODUCT_REJECTED: {
		statusLabel: 'PRODUCT REJECTED',
		extraClass: 'delete'
	},
	SERVICE_REJECTED: {
		statusLabel: 'SERVICE REJECTED',
		extraClass: 'delete'
	},
	DOCUMENT_PENDING: {
		statusLabel: 'DOCUMENT UPLOAD PENDING',
		extraClass: 'invent-pending'
	}
};

const ProductStatus = ({ statusKey, addExtraClass }) => {
	let statusLabel = statusContent[statusKey]?.statusLabel;
	let secondClass = addExtraClass
		? statusContent[statusKey]?.extraClass || ''
		: '';

	return (
		<div className={`${styles['pending-text']}${addExtraClass ? ' ' + styles[secondClass] : ''}`}>
			<div>
				<span className={`icon-alertNew icon-pending-alert`}></span>
			</div>
			<div className={styles['pending-status']}>{statusLabel}</div>
		</div>
	);
};

export default withDCOnly(ProductStatus);
